import React, { useState } from "react";
import {
  CCard,
  CCardBody,
  CForm,
  CFormLabel,
  CFormInput,
  CButton,
  CCol,
  CRow,
  CContainer,
} from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import { changeUserPassword } from "../../features/user/userSlice";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const { passwordLoading, passwordError } = useSelector((state) => state.user);

  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) {
      alert("New password and confirm password do not match.");
      return;
    }

    try {
      const payload = {
        current_password: form.currentPassword,
        new_password: form.newPassword,
        new_password_confirmation: form.confirmPassword,
      };
      await dispatch(changeUserPassword(payload)).unwrap();
      alert("Password changed successfully.");
      window.history.back();
    } catch (err) {
      alert("Failed to change password: " + err);
    }
  };

  if (passwordLoading) {
    return <div className="text-center mt-5">Loading profile...</div>;
  }
  return (
    <CContainer className="px-3 mt-4">
      <CCard className="shadow-sm border-0 rounded-4">
        <CCardBody>
          <h4 className="mb-4 text-primary">Change Password</h4>
          <CForm onSubmit={handleSubmit}>
            <CRow className="mb-3">
              <CCol md={6}>
                <CFormLabel>Current Password</CFormLabel>
                <CFormInput
                  type="password"
                  name="currentPassword"
                  value={form.currentPassword}
                  onChange={handleChange}
                  required
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol md={6}>
                <CFormLabel>New Password</CFormLabel>
                <CFormInput
                  type="password"
                  name="newPassword"
                  value={form.newPassword}
                  onChange={handleChange}
                  required
                />
              </CCol>
            </CRow>
            <CRow className="mb-4">
              <CCol md={6}>
                <CFormLabel>Confirm Password</CFormLabel>
                <CFormInput
                  type="password"
                  name="confirmPassword"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  required
                />
              </CCol>
            </CRow>
            <div className="text-end">
              <CButton type="submit" color="primary" className="me-2">
                Change Password
              </CButton>
              <CButton color="secondary" onClick={() => window.history.back()}>
                Cancel
              </CButton>
            </div>
          </CForm>
        </CCardBody>
      </CCard>
    </CContainer>
  );
};

export default ChangePassword;
